module.exports = __webpack_public_path__ + "img/5-2.c5a332c3.svg";